import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  FETCH_CHART_SUCCESS,
  SET_UPDATES_LOADING,
  SET_LOADING,
  SET_DATES,
  UPDATE_SUBSCRIPTION_FILTER,
  UPDATE_SELECTED_FILTERS,
  UPDATE_TABLE_VIEW_SELECTED,
  UPDATE_SOURCE_FILTER,
  UPDATE_CUSTOM_RANGE,
  UPDATE_DATES,
  SET_SHOW_VALIDATE_MESSAGE
} from "./onDemandRevenueSagas";
import {
  getSelectedRangeOptionWithCustom,
  getRangeOptionsWithCustom,
  getRangeOptions,
  getDateRanges
} from "../../../../utils/date-range-options";

const initialState = {
  currentUser: {},
  selectedRequestDates: {},
  selectedRangeOption: {},
  rangeOptions: [],
  periodTypeOptions: ["Daily", "Weekly", "Monthly", "Quarterly", "Yearly"],
  selectedFilters: {
    groupBySubscription: false,
    periodType: "Monthly",
    selectedSubscriptions: [],
    sourceCategory: [],
    table_view: false
  },
  filters: {
    category_sources: []
  },
  chartData: {},
  isLoading: true,
  filtersDirty: false,
  isUpdating: false,
  showValidationMessage: false
};

function getSelectedSubscription(subscriptions, sourceCategories) {
  const sourceCategoryIds = sourceCategories.map((category) => category.id);
  return subscriptions.filter((subscription) => sourceCategoryIds.includes(subscription.sourceId));
}

function getSelectedSourceCategory(subscriptions, sourceCategories) {
  const sourceCategoryIds = subscriptions.map((subscription) => subscription.sourceId);
  return sourceCategories.filter((category) => sourceCategoryIds.includes(category.id));
}

export default handleActions(
  {
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      filtersDirty: false
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      isUpdating: action.payload,
      filtersDirty: false
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_SHOW_VALIDATE_MESSAGE]: (state, action) => ({
      ...state,
      showValidationMessage: action.payload
    }),
    [SET_DATES]: (state, action) => {
      const rangeOptions = getRangeOptions(
        action.payload.endDate,
        state.currentUser.calendarStartDate
      );
      return {
        ...state,
        selectedRequestDates: action.payload || state.selectedRequestDates,
        rangeOptions: getRangeOptionsWithCustom(rangeOptions, action),
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload?.filters,
      selectedFilters: {
        ...initialState.selectedFilters,
        selectedSubscriptions: action.payload.filters.subscriptions,
        sourceCategory: getSelectedSourceCategory(
          action.payload.filters.subscriptions,
          action.payload.filters.category_sources
        )
      }
    }),
    [UPDATE_SELECTED_FILTERS]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload
      },
      filtersDirty: true
    }),
    [UPDATE_TABLE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      }
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload.data
    }),
    [UPDATE_SUBSCRIPTION_FILTER]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        sourceCategory: getSelectedSourceCategory(action.payload, state.filters.category_sources),
        selectedSubscriptions: action.payload
      },
      filtersDirty: true
    }),
    [UPDATE_SOURCE_FILTER]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        sourceCategory: action.payload,
        selectedSubscriptions: getSelectedSubscription(state.filters.subscriptions, action.payload)
      },
      filtersDirty: true
    })
  },
  initialState
);
